module.exports = require("@swa-ui/placements/src/HtmlValue/HtmlValue.module.scss");